import { createSlice } from '@reduxjs/toolkit';
import { FeedbackQuestion } from '../interfaces/index.type';

const initialState: FeedbackQuestion = {
  questionTypes: null,
  clearInteraction: false,
  isFeedbackFormDirty: false,
  skipTracingInitialQuestions: [],
  addedPhoneNumber: '',
  addedIdentifier: ''
};

const FeedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    storeFeedbackQuestionTypes: (state, action) => {
      state.questionTypes = action.payload;
    },
    resetFeedbackQuestionTypes: state => {
      state.questionTypes = null;
    },
    clearInteraction: (state, action) => {
      state.clearInteraction = !state.clearInteraction;
    },
    setIsFeedbackFormDirty: (state, action) => {
      state.isFeedbackFormDirty = action.payload;
    },
    setSkipTracingInitialQuestions: (state, action) => {
      state.skipTracingInitialQuestions = action.payload;
    },
    setAddedPhoneNumber: (state, action) => {
      const { phoneNumber, identifier } = action.payload;
      state.addedPhoneNumber = phoneNumber;
      state.addedIdentifier = identifier;
    }
  }
});

export const {
  storeFeedbackQuestionTypes,
  resetFeedbackQuestionTypes,
  clearInteraction,
  setIsFeedbackFormDirty,
  setSkipTracingInitialQuestions,
  setAddedPhoneNumber
} = FeedbackSlice.actions;

export default FeedbackSlice.reducer;
